<template>
  <v-container
    id="view-credit-billing-reports"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <Breadcrumb :items="items" ></Breadcrumb>
        <h1>
          {{ accountData.development }} Reports
        </h1>

      </v-col>

      <v-col cols="12">
        <h2>Development Reports</h2>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="accountData.reports"
            :search="search"
            item-key="id"
            :items-per-page=100
            :footer-props="listSize"
            class="elevation-1"
          >

            <template #item.file_type="{ value }">
              <v-chip v-if="value === 'combined'" color="#1867c0" dark>Meter Issue Report</v-chip>
              <v-chip v-else color="#bbb" dark>-</v-chip>
            </template>

            <template #item.file_name="{ value, item }">
              <v-btn
                x-small
                :loading="downloadLoading"
                :disabled="downloadLoading"
                color="blue-grey"
                class="ma-2 white--text"
                fab
                @click="downloadFile(value, item.id)"
              >
                <v-icon dark>
                  mdi-cloud-download
                </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import {get} from "vuex-pathify";
import Breadcrumb from "@/components/Breadcrumb";
import {date} from "@/mixins/date";
import {creditBilling} from "@/mixins/credit-billing";
import {dataTables} from "@/mixins/data-tables";

export default {
  name: "CreditBillingReports",
  props: {
    id: String
  },
  components: {
    Breadcrumb,
  },
  mixins: [date, creditBilling, dataTables],
  computed: {
    accountData: get('creditBilling/developmentReports'),
    items() {
      return [
        {
          text: 'All Developments',
          disabled: false,
          exact: true,
          to: '/credit-billing',
        },
        {
          text: this.accountData.development,
          disabled: false,
          exact: true,
          to: '/credit-billing/' + this.id,
        },
        {
          text: "All Bills",
          disabled: true,
        }
      ];
    }
  },
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  data: () => ({
    filterType: "all",
    loaded: true,
    downloadLoading: false,
    downloadedFiles: [],
    listSize: {
      "items-per-page-options": [10, 25, 50, 100]
    },
    search: '',
    headers: [
      {text: "Applicable at", value: 'file_date'},
      {text: "Type", value: 'file_type'},
      {text: "", value: 'file_name'},
    ],
  }),
  methods: {
    async downloadFile(fileRef, id) {
      this.downloadLoading = true;

      if (await this.triggerCreditFileDownload("download-development-report", id, fileRef)) {
        this.downloadedFiles.push(fileRef);
      }

      this.downloadLoading = false;
    },
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", {title: "Loading Development Reports"});


      const success = await this.$store.dispatch("creditBilling/getDevelopmentReports", {
        developmentRef: this.id
      });

      if (!success) {
        await this.$router.push("/credit-billing/" + this.id);
        return;
      }

      this.loaded = true;

      await this.$store.dispatch("loader/loaderCancel");

    }
  }
}
</script>

<style lang="scss" scoped>
.warn p {
  margin-bottom: 0px;
  font-size: 0.9rem;
}
</style>
